import actions from '../actions/reports';

export const getEndOfDayReport = (payload) => {
  return actions.getEndOfDayReport(payload);
};

export const getCourierShiftReport = (url, payload) => {
  return actions.getCourierShiftReport(url, payload);
};

export const getCourierDistanceReport = (url, payload) => {
  return actions.getCourierDistanceReport(url, payload);
};

export const getOrderStatusReport = (url, payload) => {
  return actions.getOrderStatusReport(url, payload);
};

export const exportCourierDistanceReport = (payload) => {
  return actions.exportCourierDistanceReport(payload);
};
